<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance "
         id="operatorSelectModal">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="login-form">
          <div class="logo_form">
            <img :src="getTranslations.project_config_modal_img" alt="">
          </div>
          <div class="form_title">
            <h1>{{ getTranslations.home_modals_select_operator_register }}</h1>
          </div>
          <div class="form_title" v-if= "!show2stepsOnlyOrNoneInForgot()">
            <h1>{{ getTranslations.visitor_sign_up_1_single_country_activate_free_trial }}</h1>
          </div>
          <div class="form_title" v-if= "show2stepsOnlyOrNoneInForgot()">
            <h1>{{ getTranslations.visitor_sign_up_1_single_country_two_steps }}</h1>
          </div>
          <div class="col-lg-12">
            <div :class="['StandardRegSteps_Container ', show2stepsOnlyOrNoneInForgot() ? 'twoStepRegSteps_Container' : '' ]">
              <div :class="['StandardRegSteps_step ' , show2stepsOnlyOrNoneInForgot() ? 'twoStepRegSteps_step' : 'step_done' ]" >1
              </div>
              <div :class="['StandardRegSteps_step ' , show2stepsOnlyOrNoneInForgot() ? 'twoStepRegSteps_step inactive' : 'inactive' ]" >2
              </div>
              <div class="StandardRegSteps_step inactive" v-if="!show2stepsOnlyOrNoneInForgot()">3
              </div>
            </div>
          </div>
        </div>
        <div class="modal__body">
          <div class="operators_selection_wrap">
            <p class="center">{{ getTranslations.home_modals_select_operator_my_operator_is }} </p>
            <div class="operators_radio">
              <label v-for="(operator, index) in multiOperatorInfo.multiOperatorKeys"
                     v-if="multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage[index]"
                     class="operators_radio operators_radio_inline"
                     :key="index">
                <img class="operators_icon"
                     :src="getOperatorImage(index)"
                     :alt="getOperatorDisplayName(index)">
                <input type="radio"
                       name="operator"
                       :value="operator"
                       v-model="inputOperator"
                       @click="check();getOrdinalByOperator(operator);">
                <span></span>
              </label>
            </div>
            <div class="operators_error_msg"
                 v-if="!inputOperator && btnSubmitted">
              <span class="form-group__feedback">
                {{ getTranslations.home_modals_select_operator_my_operator_is }}
              </span>
            </div>
          </div>
          <p>{{ getAbovePlaceholderText() }}</p>
          <form action="" v-on:submit.prevent="goToNext()">
            <div  :class="[ 'form-group form-group--icon', !errors ? 'has-success' : 'has-warning' ]">
              <input type="text"
                     class="mobile form-group__textfield phone_input"
                     :placeholder="getPlaceholder()"
                     @keyup="check"
                     v-model="inputMsisdn"/>
              <span class="form-group__feedback"
                    v-if="ERROR_REDIRECT_MESSAGE">
                {{ getMessage(mapErrorMessages(ERROR_REDIRECT_MESSAGE)) }}
              </span>
            </div>
            <div class="form-footer">
              <p> {{ getTranslations.visitor_sign_up_1_single_country_free_for }}</p>
              <a v-if="checkIntegration"
                 style="cursor: pointer"
                 target="_blank"
                 class="alter_flow_link"
                 :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')">
                {{ getTranslations.visitor_operator_selection_modal_terms_conditions_click }}
              </a>
            </div>
            <div @click.prevent="goToNext()"
               style="cursor:pointer"
               :class="['btn btn--medium btn--main', (errors)? 'deactivated' : '']">
              {{ getTranslations.visitor_sign_up_1_single_country_submit_button_continue }}
          </div>
            <br><br>
            <a style="cursor: pointer"
               @click.prevent="exit()"
               class="alter_flow_link">
              {{ getTranslations.project_config_visitor_register_2_exit }}
            </a>
          </form>
          <p v-if="showDisclaimer()">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_disclaimer') }}</p>
          <p  class="form-group__feedback reg_notice" v-if="inputOperator && !checkIntegration">
            {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_terms_conditions') }}
            <a style="cursor: pointer"
               target="_blank"
               class="alter_flow_link"
               :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')">
              {{ getTranslations.visitor_operator_selection_modal_terms_conditions_click }}
            </a>
          </p>
        </div>
        <div class="modal__footer"></div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import FlowMixin from '@/common/mixins/flow';


export default {
  name: 'operatorSelectionModal',
  mixins: [IntegrationMixin, FlowMixin],
  created() {
    this.inputMsisdn = (this.getTranslations.visitor_msisdn_input_prefix_value) ? this.getTranslations.visitor_msisdn_input_prefix_value : '';
    const numOfVisibleOperators = (this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.filter(item => item)).length;
    if (numOfVisibleOperators === 1) {
      const position = this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.indexOf(true);
      const operator = this.multiOperatorInfo.multiOperatorKeys[position];
      this.storeOperator(operator);
      this.inputOperator = operator;
    }
    this.showModal();
  },
  data() {
    return {
      inputMsisdn: '',
      inputOperator: '',
      errors: false,
      btnSubmitted: false,
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
    ]),
    ...mapActions('common', [
      'storeOperator',
    ]),
    exit() {
      window.location.href = 'https://google.com';
    },
    getPlaceholder() {
      if (!this.inputOperator) return this.getTranslations.visitor_sign_up_1_single_country_placeholder;
      return this.getTranslationByOperatorIfExists(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_placeholder');
    },
    getAbovePlaceholderText() {
      if (!this.inputOperator) return this.getTranslations.visitor_sign_up_1_single_country_above_placeholder;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_above_placeholder');
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.inputOperator;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_disclaimer');
    },
    mapErrorMessages(resMessage) {
      this.errors = true;
      if (resMessage === 'MSISDN_INVALID') {
        return 'visitor_sign_up_invalid_msisdn_msg';
      } else if (resMessage === 'ALREADY_REGISTERED' || resMessage === 'ALREADY_SUB_USER') {
        return 'visitor_sign_up_msisdn_already_registered';
      } else if (resMessage === 'MSISDN_NOT_EXIST') {
        return 'visitor_sign_up_msisdn_not_exists';
      } else if (resMessage === 'MSISDN_BLACKLISTED') {
        return 'visitor_sign_up_msisdn_blacklisted';
      } else if (resMessage === 'BLOCKED_USER') {
        return 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resMessage === 'SERVER_ERROR') {
        return 'home_profile_profile_edit_server_unvailable';
      } else if ((resMessage === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resMessage === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resMessage === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        return 'visitor_sign_up_warning_third_party_error';
      }
      this.errors = false;
      return '';
    },
    getOrdinalByOperator(operator) {
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((res) => {
        this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
      });
    },
    check() {
      const validMsisdnRegex = /^[0-9]||[()+-]{0,20}$/;
      const validMsisdn = this.inputMsisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
        this.errors = true;
      } else {
        this.errors = false;
        this.ERROR_REDIRECT_MESSAGE = '';
      }
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    goToNext() {
      this.btnSubmitted = true;
      if (this.inputMsisdn && this.inputOperator) {
        this.setRegistrationInfo(this.inputMsisdn);
        this.storeOperator(this.inputOperator);
        this.setActiveIntegrationInfo([{ key: 'msisdn', value: this.inputMsisdn }, { key: 'operator', value: this.inputOperator }, { key: 'lang', value: this.getLocale }]);
        this.integrationRedirect();
      } else {
        this.errors = true;
      }
    },
    checkIntegration() {
      if (this.integrationHeader === this.availableIntegrations.DU_ETISALAT.name) {
        return true;
      }
      return false;
    },
    showModal() {
      const vm = this;
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          vm.$emit('close');
          $('.modal, .modal-overlay').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapGetters('i18n', [
      'getTranslationByOperatorIfExists',
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/OperatorSelectionModal.vue